import { configureStore } from '@reduxjs/toolkit';
import sessionReducer from './reducers/session.reducer';

const store = configureStore({
  reducer: {
    sessionReducers: sessionReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Named export for require() compatibility (used in api.ts interceptor)
export { store as Store };

export default store;
